import React from 'react'
import ProfileImageWithFallback from '../../../../../common/ProfileImageWithFallback'
import { useSelector } from 'react-redux';

export default function ParticipateImage() {
      const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  return (
    <>
      <ProfileImageWithFallback url={profile.profile_image} />
    </>
  )
}
